import { call, put, select, takeLatest } from "redux-saga/effects";
import { FETCH_OPPORTUNITIES_REQUEST, fetchOpportunitiesFailure, fetchOpportunitiesSuccess } from "../../actions/opportunities/opportunitesActions";
import { fetchSpotOpportunity, getPageWiseUserCampaignList } from "../../../../services/iqApiV2";
import { normalizeMappedProducts } from "../../../../utilities/uiUtils";


export function* fetchOpportunitiesSaga() {
  try {
    const payload = yield select(
      (state) => state?.opportunitiesReducer?.payload
    );
    const { clientName, accountName, userId, type } = payload;

    // 🔹 Fetch both datasets
    const data = yield call(fetchSpotOpportunity, clientName, accountName, userId, type);
    const dataOfExistingNurtures = yield call(
      getPageWiseUserCampaignList,
      userId                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        
    );

    // 🔹 Create a Set of nurture opportunity IDs for quick lookup

      const nurtureMap = new Map(
        (dataOfExistingNurtures || [])
          .filter((item) => item?.opportunity_id && item.opportunity_id !== "None")
          .map((item) => [item.opportunity_id, item.status])
      );

      console.log("spot opp existing nurtures map", nurtureMap);

      // ✅ Then use it in your normalized data
      const normalizedData = (data || []).map((item) => {
        const mappedProducts = normalizeMappedProducts(item?.mapped_products);
        const status = nurtureMap.get(item?.opportunity_id);

        return {
          ...item,
          mapped_products: mappedProducts,
          auto_nurture_in_progress: nurtureMap.has(item?.opportunity_id),
          auto_nurture_status: status || null,
        };
      });


    // 🔹 Mark items with auto_nurture_in_progress flag
    const enhancedData = normalizedData;

    // 🔹 Sort bookmarked items first
    const sortedData = [...enhancedData].sort((a, b) => {
      const aBookmarked = a?.is_bookmarked ? 1 : 0;
      const bBookmarked = b?.is_bookmarked ? 1 : 0;
      return bBookmarked - aBookmarked;
    });
console.log("spotOppData",sortedData)


    yield put(fetchOpportunitiesSuccess(sortedData));
  } catch (error) {
    console.error("Error in fetchOpportunitiesSaga:", error);
    yield put(fetchOpportunitiesFailure(error.message));
  }
}


// Watcher Saga
export function* watchOpportunitiesData() {
  yield takeLatest(FETCH_OPPORTUNITIES_REQUEST, fetchOpportunitiesSaga);
}
